//pages

import {
  Dashboard,
  Seemore,
  Setting,
  SettingChangePassword,
  Batch,
  RetireBatch,
  RequestBatch,
  IssuedbatchSecond,
  Issuedbatch,
  Requests,
  ReceiveInventory,
} from "./pages";

//routes
import DetailsPage from "../../components/DetailsPage";

import { pouRoutes, commonRoutes } from "../../Services/Routes/APP";

//admin routes export

export const adminroutes = [
	{
		id: `pou-122`,
		exact: false,
		path: pouRoutes?.root,
		component: Dashboard,
	},
	{
		id: `pou-123`,
		exact: false,
		path: pouRoutes?.dashboard,
		component: Dashboard,
	},
	{
		id: `pou-123`,
		exact: false,
		path: pouRoutes?.dashbordSeeMore,
		component: Seemore,
  },
  // {
  //   id: `pou-124`,
  //   exact: false,
  //   path: pouRoutes?.dashboardDetails,
  //   component: RequestDetails,
  // },
	{
		id: `pou-128`,
		exact: false,
		path: pouRoutes?.setting,
		component: Setting,
	},
	{
		id: `pou-129`,
		exact: false,
		path: pouRoutes?.changePassword,
		component: SettingChangePassword,
	},
	{
		id: `pou-130`,
		exact: false,
		path: pouRoutes?.batch,
		component: Batch,
	},
	{
		id: `pou-131`,
		exact: false,
		path: pouRoutes?.retireBatch,
		component: RetireBatch,
	},
	{
		id: `pou-132`,
		exact: false,
		path: pouRoutes?.issuedBatchManually,
		component: IssuedbatchSecond,
	},
	{
		id: `pou-133`,
		exact: false,
		path: pouRoutes?.requests,
		component: Requests,
	},
	{
		id: `pou-134`,
		exact: false,
		path: pouRoutes?.receiveInventory,
		component: ReceiveInventory,
	},
	{
		id: `pou-135`,
		exact: false,
		path: pouRoutes?.request_inventory,
		component: RequestBatch,
	},
	{
		id: `pou-136`,
		exact: false,
		path: pouRoutes?.issuedBatch,
		component: Issuedbatch,
	},
	{
		id: `pou-137`,
		exact: false,
		path: commonRoutes?.batch?.details,
		component: DetailsPage,
	},
	{
		id: `pou-138`,
		exact: false,
		path: commonRoutes?.request + commonRoutes?.details,
		component: DetailsPage,
	},
];
